import api from "./api";

// Capa de servicios API del dominio "respuestas rápidas" (FSD / capa API transversal).
// Wrappers de transporte finos: la construcción de payloads/params vive en el
// componente; aquí solo se centraliza el endpoint (un único lugar que tocar si cambia).

// --- CRUD ---
export const listQuickMessages = (params) =>
  api.get("/quick-messages/list", { params });
export const findQuickMessageById = (quickMessageId) =>
  api.get(`/quick-messages/${quickMessageId}`);
export const createQuickMessage = (payload) =>
  api.post("/quick-messages", payload);
export const updateQuickMessage = (quickMessageId, payload) =>
  api.put(`/quick-messages/${quickMessageId}`, payload);
export const deleteQuickMessage = (quickMessageId) =>
  api.delete(`/quick-messages/${quickMessageId}`);

// --- Media ---
export const uploadQuickMessageMedia = (quickMessageId, formData) =>
  api.post(`/quick-messages/${quickMessageId}/media-upload`, formData);
export const deleteQuickMessageMedia = (quickMessageId) =>
  api.delete(`/quick-messages/${quickMessageId}/media-upload`);
